import { ActionTypes } from 'redux/utils/Form'

export default ActionTypes('ASSESSMENT_SERVICE_PLAN_NEED')